import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { Observable, Subscription } from 'rxjs';

// required for swiper 11 (which replaces the swiper 9 which was replacing slides)
import { register } from 'swiper/element/bundle';

register();

if (environment.production) {
  enableProdMode();
}

declare global {
  interface Window {
    startAngularApp: () => void;
  }
}


window.startAngularApp = () => {
  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.log(err));
};


  

/*
const originalCreate = Observable.create;

Observable.create = function (subscribeFn: any) {
  console.warn('Observable.create used!', subscribeFn);
  return originalCreate.call(this, subscribeFn);
};
*/

const originalCreate = Observable.create;

Observable.create = function(subscribeFn: any): Observable<any> {

  return new Observable(observer => {
    //console.warn('Observable.create used!', subscribeFn);

    let innerSub: Subscription | void;

    try {
      // Execute original subscription function
      innerSub = subscribeFn(observer);
    } catch (err) {
      observer.error(err);
      return undefined;
    }

    // If the returned value is NOT a Subscription, wrap it
    if (!(innerSub instanceof Subscription)) {
      return new Subscription();
    }

    return innerSub;
  });
};